import { render, staticRenderFns } from "./TVA.vue?vue&type=template&id=2fb0614d"
import script from "./TVA.vue?vue&type=script&lang=js"
export * from "./TVA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports